import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import {
    Button,
    ThreeDotsIcon,
} from '@sentara-health/optimahealth_web';
import { NavigateConst } from 'common';


const ViewTaxDropDown: React.FC = () => {
    const { t } = useTranslation();
    const year: number = new Date().getFullYear();
    const navigate = useNavigate();

    const handleClick = async (selected: string) => {
        const selectedYear = selected === 'current' ? year : year - 1;
        
        const selectedOption = t('common.selectedOption');
        localStorage.setItem(selectedOption, String(selectedYear));
        navigate(NavigateConst.dropdownValue);
    }

    return (
        <div className="d-flex align-items-center position-relative flex-shrink-0">
            <div className="d-flex align-items-center">
                    <Button
                        variant="icon_btn"
                        className="p-2"
                        iconLeft={<ThreeDotsIcon width={40} height={40} />}
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                        type="button"
                        id="btnGroupDrop1"
                    />
                    
                    <ul
                        className="dropdown-menu dropdown-menu-custom"
                        aria-labelledby="btnGroupDrop1"
                    >

                        <li>
                            <Button
                                dataTestId='currentYearButton'
                                variant='dropdown-item'
                                onClick={() => handleClick('current')}
                                className="text-nowrap"
                            >
                                {t('medicalClaims.taxYearSummaryCurrentYear')}
                            </Button>
                        </li>
                        <li>
                            <Button
                                dataTestId='previousYearButton'
                                variant='dropdown-item'
                                onClick={() => handleClick('previous')}
                                className="text-nowrap"
                            >
                                {t('medicalClaims.taxYearSummaryPreviousYear')}
                            </Button>
                        </li>
                    </ul>
            </div>
        </div>
    );
};

export default ViewTaxDropDown;
